module.exports = "<div class=\"container\">\n  <div class=\"content\">\n    <div style=\"font-size: 28px\"> 400 Error</div>\n    <div style=\"font-size: 18px\"> La tarjeta solicitada no esta activa</div>\n    <div class=\"title\"></div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/error400/error400.component.html
// module id = ./src/app/components/error400/error400.component.html
// module chunks = main